import { render, staticRenderFns } from "./CanteenPoster.vue?vue&type=template&id=0f000908&scoped=true&"
import script from "./CanteenPoster.vue?vue&type=script&lang=js&"
export * from "./CanteenPoster.vue?vue&type=script&lang=js&"
import style0 from "./CanteenPoster.vue?vue&type=style&index=0&id=0f000908&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f000908",
  null
  
)

export default component.exports